import { useEffect, useState } from "react"
import { FaAngleLeft, FaAngleRight } from "react-icons/fa6";
import { IoSearch, IoFilter } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const Products = () => {

    const Navigate = useNavigate()

    const [products, setProducts] = useState([])
    const [sliceCount, setSliceCount] = useState({ from: 0, to: 15 })
    const [showCatDropDown, setShowCatDropDown] = useState(false)
    const [currentCat, setCurrentCat] = useState(category.all)

    const filterProducts = (cat) => {
        if (cat === category.all) {
            setProducts(demoProducts);
        } else {
            const filteredProducts = demoProducts.filter((item) => item.category === cat);
            setProducts(filteredProducts);
        }
    };

    const changeCurrentCat = (cat) => {
        setCurrentCat(cat)
        filterProducts(cat)
        setShowCatDropDown(false)
    }

    const toggleShowCatDropDown = () => {
        setShowCatDropDown(!showCatDropDown)
    }

    const addSlice = () => {
        if ((sliceCount.to >= products.length)) {
            setSliceCount({ from: sliceCount.from, to: sliceCount.to })
        } else {
            setSliceCount({ from: sliceCount.to, to: sliceCount.to + 15 })
            document.querySelector('#table-container').scrollTo(0, 0)
        }
    }

    const cutSlice = () => {
        if ((sliceCount.from <= 0)) {
            setSliceCount({ from: sliceCount.from, to: sliceCount.to })
        } else {
            setSliceCount({ from: sliceCount.from - 15, to: sliceCount.from })
            document.querySelector('#table-container').scrollTo(0, 0)
        }
    }

    useEffect(() => {
        setProducts(demoProducts)
    }, [])

    return (
        <>
            <div className=" h-[20vh] sm:h-[10vh] flex justify-center items-center sm:items-end">
                <div className=" w-[95%] flex flex-col-reverse gap-2 sm:flex-row justify-between items-center">
                    <div className=" relative flex-1 text-nowrap">
                        <div onClick={toggleShowCatDropDown} className=" cursor-pointer flex items-center gap-4">
                            <div className=" flex gap-2 items-center"><IoFilter /><span>Filter By Category</span></div>
                            <div className=" text-sm font-semibold py-1 px-3 rounded-full bg-slate-300 capitalize">{currentCat}</div>
                        </div>
                        {showCatDropDown &&
                            <div className=" absolute m-auto z-20 rounded-md overflow-hidden bg-white shadow-lg border-2 border-slate-300 min-w-[200px] mt-2 divide-y-2">
                                {
                                    Object.values(category).map((item, index) => (
                                        <div key={index} onClick={() => changeCurrentCat(item)} className={`${(currentCat === item) && 'bg-slate-300'} py-2 px-4 hover:bg-slate-300 cursor-pointer capitalize`}>{item}</div>
                                    ))
                                }
                            </div>
                        }
                    </div>
                    <form action="" className=" relative inline-block">
                        <input type="text" className=" w-full py-2 px-4 pr-12" placeholder="Search Product" name="" id="" />
                        <button className=" absolute right-0 top-[50%] -translate-y-[50%]" type="submit"><IoSearch /></button>
                    </form>
                </div>
            </div>
            <div className=" h-[60vh] sm:h-[70vh] flex justify-center items-start pt-6">
                <div className=" w-[95%] max-h-[95%] border-2 border-slate-300 rounded-md overflow-y-auto overflow-x-auto small-scrollbar scrollbar">
                    <table className=" w-full relative">
                        <thead className=" bg-tripstore-black text-white sticky top-0 z-[1]">
                            <tr className=" text-nowrap *:py-1 *:px-3">
                                <td>S/N</td>
                                <td>Product Name</td>
                                <td>Qty</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (products.length > 0) ?
                                    <>
                                        {
                                            products.slice(sliceCount.from, sliceCount.to).map((item, index) => (
                                                <tr onClick={() => Navigate(`/admin/inventory/detail/${item.id}`)} key={index} className=" *:py-1 *:px-3 even:bg-slate-200 cursor-pointer hover:bg-slate-300 active:bg-tripstore-black active:text-white">
                                                    <td>{index + 1 + sliceCount.from}</td>
                                                    <td>{item.product_name}</td>
                                                    <td>{item.qty}</td>
                                                </tr>
                                            ))
                                        }
                                    </>
                                    :
                                    <tr>
                                        <td colSpan={10000} className=" py-1 px-3 text-center text-gray-500 font-semibold">No product</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <div className=" h-[10vh] w-[95%] m-auto flex justify-between items-center">
                <button onClick={() => cutSlice()} className=" flex items-center gap-4 hover:bg-slate-200"><FaAngleLeft /> <span className=" hidden md:inline">Previous</span></button>
                <div className={`${(products.length <= 0) && " hidden"} text-sm font-semibold text-gray-500`}>Showing {1 + sliceCount.from} to {(sliceCount.to >= products.length) ? products.length : sliceCount.to} of {products.length}</div>
                <button onClick={() => addSlice()} className=" flex items-center gap-4 hover:bg-slate-200"><span className=" hidden md:inline">Next</span> <FaAngleRight /></button>
            </div>
            {showCatDropDown && <div onClick={toggleShowCatDropDown} className=" absolute top-0 left-0 w-full h-full bg-black/10 z-10"></div>}
        </>
    )
}

export default Products

const category = {
    all: 'all',
    healthAndBeauty: 'health & beauty',
    homeAndOffice: 'home & office',
    appliances: 'appliances',
    phonesAndTablets: 'phones & tablets',
    computing: 'computing',
    electronics: 'electronics',
    fashion: 'fashion',
    babyProducts: 'baby products',
    gaming: 'gaming',
    sportingGoods: 'sporting goods',
    others: 'others'
}

const demoProducts = [
    { id: 1, product_name: "Product", qty: 100, category: category.fashion },
    { id: 2, product_name: "Product2", qty: 150, category: category.appliances },
]